import Reflux from 'reflux';

const SimulatorActions = Reflux.createActions({
  simulate: { asyncResult: true },
});

export default SimulatorActions;



// WEBPACK FOOTER //
// ./src/web/simulator/SimulatorActions.js